jQuery(document).ready(function($){
  if($("button[data-add-to-cart]").length) {
    $("body").on("click", "button[data-add-to-cart]", function(){
      console.log("add to cart");
      const $form = $(this).closest("form");
      const variant_id = $form.find("select[name=id] option:selected").val();
      const variant_price = productJson.variants.find(x => x.id == variant_id).price / 100;
      ttq.track('AddToCart', {
        content_id: variant_id,
        content_type: 'product',
        content_name: productJson.title,
        quantity: 1,
        price: variant_price,
        value: variant_price,
        currency: 'USD',
      });
    });
  }
  
  $(document).on("click", "#MobileNav .link_megamenu-parent", function(){
  	const target = $(this).attr("data-target");
    if($(".submenu-item-wrapper[data-menu-item=" + target + "]").length) {
      $("#MobileNav").addClass("expanded");
      $(".submenu-item-wrapper[data-menu-item=" + target + "]").addClass("active");
    }
  });
  
  $(document).on("click", "#mobile-nav-wrapper .toOrigin", function(e){
  	e.preventDefault();
    $("#MobileNav").removeClass("expanded");
    $(this).parent().removeClass("active");
    $("#mobile-nav-wrapper .submenu-wrapper .menu-section.has-submenu").addClass("collapsed");
  });
  
  $(document).on("click", "#mobile-nav-wrapper .close-mobile-nav, #transparentBG", function(){
  	$("#MobileNav").removeClass("expanded");
    $("#mobile-nav-wrapper .submenu-wrapper .submenu-item-wrapper").removeClass("active");
    $("#mobile-nav-wrapper .submenu-wrapper .menu-section.has-submenu").addClass("collapsed");
  });
  
  $(document).on("click", "#mobile-nav-wrapper .submenu-wrapper .menu-section h4", function(){
  	$(this).parent().toggleClass("collapsed");
  });
  
  if($(".fixedBar").length) {
    $(document).on("change", '.fixedBar form select, .fixedBar form input[type=radio]', function(){
      const selectedId = $(this).closest("form").find("select[name=id]").val();
      console.log(selectedId);
      if(selectedId) {
        $(".bis-trigger").removeClass("active");
      } else {
      	$(".bis-trigger").addClass("active");
      }
    });
  }
  $(document).on("click", ".sidecart #reco-prods .optionWrapper", function(){
  	let price = $(this).find('.swatch-element').attr('data-price');
    let compare_price = $(this).find('.swatch-element').attr('data-compare-price');

    $(this).closest('li').find('[data-product-price]').html('<span class="currency">$</span> ' + price / 100 + '</span>');
    $(this).closest('li').find('[data-compare-price]').html('$ ' + compare_price / 100);
  });

  $('body')
  .on('click', '.codmw2__banner-button', (event) => {
    var $video = $('.codmw2__banner-video');

    if ( $video.length ) {
      event.preventDefault();

      $('body').addClass('codmw2__banner-video__active');
      $video.addClass('is-shown');
    }
  })
  .on('click', '.codmw2__banner-video svg', (event) => {
    event.preventDefault();

    $('body').removeClass('codmw2__banner-video__active');
    $('.codmw2__banner-video').removeClass('is-shown');
    $('.codmw2__banner-video iframe').attr("src", $('.codmw2__banner-video iframe').attr("src"));
  })
});